import React from 'react';

const ThankYou = ({setthanku, centerClass}) =>{

    return(

        <>
            <div className={`msg__container forClubForm ${centerClass}`}>
                <div className="msg__content">
                    <h1 className={`msg__content--title text-jost-sb-50 ${centerClass}`}>Thank you!</h1>
                    <p className="msg__content--para text-ops-rg-16">We’ve received your message and we’ll get back to you within 24 hours..</p>
                    <div className={`msg__content--links ${centerClass}`}>

                        <button href="#" target="_self" className="res-btn-primary"
                                onClick={()=>setthanku(false)}
                        >

                            ok, thanks
                        </button>
                    </div>
                </div>
            </div>
        </>
    );

}
export default ThankYou
